import { LomaFunction } from "../LomaFunction";
import { LomaVariable } from "../LomaVariable";
import { DataTypes } from "./DataTypes";

export class Trigonemtry
{
  static variables:LomaVariable<any>[] = 
  [ 
    LomaVariable.create( "PI", Math.PI, DataTypes.Number ).setInfo(
      {
        en: "Ratio of a circle's circumference to its diameter"
      }
    ),

    LomaVariable.create( "SQRT1_2", Math.SQRT1_2, DataTypes.Number ).setInfo(
      {
        en: "Square root of ½"
      }
    ),

    LomaVariable.create( "SQRT2", Math.SQRT2, DataTypes.Number ).setInfo(
      {
        en: "Square root of 2"
      }
    ),

    LomaVariable.create( "RADIANS_TO_DEGREES", 180 / Math.PI, DataTypes.Number ).setInfo(
      {
        en: "Convert from radians to degrees"
      }
    ),

    LomaVariable.create( "DEGREES_TO_RADIANS", Math.PI / 180, DataTypes.Number ).setInfo(
      {
        en: "Convert from degress to radians"
      }
    )
    
  ]

  static functions:LomaFunction[] =
  [
    LomaFunction.forNumberIO( "sin", "value", ( value ) => Math.sin( value )     
    ).setInfo( { en: "Returns the sin of the value (radians)" }),

    LomaFunction.forNumberIO( "cos", "value", ( value ) => Math.cos( value )      
    ).setInfo( { en: "Returns the cos of the value (radians)" }),

    LomaFunction.forNumberIO( "tan", "value", ( value ) => Math.tan( value )      
    ).setInfo( { en: "Returns the tan of the value (radians)" }),

    LomaFunction.forNumbersWith( "atan2", [ "y", "x" ], ( values ) => Math.atan2( values[ 0 ], values[ 1 ] )    
        ).setInfo( 
          { en: "Returns the angle in radians of a direction with [x|y]" }
    ),
  ]   
  
}